import React, { useEffect, useState } from "react";

import { localizedText } from "shared/lib/localizedMap";
import { Button, LabeledField, Modal, Select } from "shared/ui";

import { useMenuEditorContext } from "features/MenuEditor/context";

export const MoveItemDialog = () => {
    const state = useMenuEditorContext();
    const item = state.dialog.kind === "moveItem" ? state.dialog.item : null;

    const [categoryId, setCategoryId] = useState<number | null>(null);

    useEffect(() => {
        if (item) setCategoryId(item.menuCategoryId);
    }, [item]);

    if (!item || categoryId === null) return null;

    const submit = async () => {
        const moved = await state.mutations.moveItem(item.id, categoryId);
        if (moved) state.closeDialog();
    };

    const canSubmit = categoryId !== item.menuCategoryId && !state.mutations.saving;

    return (
        <Modal
            open
            onClose={state.closeDialog}
            title="Перенести в категорию"
            maxWidth="xs"
            actions={
                <>
                    <Button
                        variant="outlined"
                        color="neutral"
                        disabled={state.mutations.saving}
                        onClick={state.closeDialog}
                    >
                        Отмена
                    </Button>
                    <Button variant="contained" disabled={!canSubmit} onClick={submit}>
                        Перенести
                    </Button>
                </>
            }
        >
            <LabeledField
                label="Категория"
                hint={`«${localizedText(item.name, state.locale)}» встанет в конец выбранной категории`}
            >
                <Select
                    value={categoryId}
                    onChange={(value) => setCategoryId(Number(value))}
                    options={state.categories.map((category) => ({
                        value: category.id,
                        label: localizedText(category.name, state.locale),
                    }))}
                />
            </LabeledField>
        </Modal>
    );
};
